// test2758
(2758 && 0);
